import { Injectable } from '@angular/core';

/**
 * One bit of shared state: is the session being torn down right now?
 *
 * Lives on its own so SweetAlertService can read it without depending on
 * SessionTerminationService, which would be a dependency cycle.
 */
@Injectable({ providedIn: 'root' })
export class SessionStateService {
  private terminating = false;

  get isTerminating(): boolean {
    return this.terminating;
  }

  /**
   * True between landing on /authredirect and the portal deciding where to send the user.
   *
   * A rejection during that window means the account was already deactivated before this session
   * began, so there is no work in progress to interrupt and nothing for a dialog to explain on top
   * of a shell the user should never have seen. AuthredirectComponent opens the window; whoever
   * settles the check closes it.
   */
  private signingIn = false;

  get isSigningIn(): boolean {
    return this.signingIn;
  }

  beginSignIn(): void {
    this.signingIn = true;
  }

  endSignIn(): void {
    this.signingIn = false;
  }

  /** Returns false if termination was already under way, so the caller can bail out. */
  claimTermination(): boolean {
    if (this.terminating) {
      return false;
    }
    this.terminating = true;
    return true;
  }
}
